<script lang="ts">
	import Cell from './Cell.svelte'
	import type { Columns } from './types'
	import { _ } from '@repo/i18n'
	import { Checkbox } from '@repo/ui'
	import { type Snippet, createEventDispatcher } from 'svelte'

	interface Props {
		rows?: any
		columns?: Columns<any>
		rowClass?: string
		selectable: boolean
		selectedItem?: any
		multiSelect: boolean
		selectedItems?: any[]
		cell?: Snippet<[any]>
	}

	let {
		rows = [],
		columns = [],
		rowClass = '',
		selectable,
		selectedItem = $bindable(null),
		multiSelect,
		selectedItems = $bindable([]),
		cell,
	}: Props = $props()

	const dispatch = createEventDispatcher()

	function handleClick(row: object) {
		if (!selectable) {
			return
		}

		if (selectedItem === row) {
			selectedItem = null
		} else {
			selectedItem = row
			dispatch('select', selectedItem)
		}
	}

	function handleSelectChanged(event: CustomEvent<boolean>, row: any) {
		const selected = event.detail
		if (selected) {
			selectedItems.push(row)
		} else {
			selectedItems = selectedItems.filter((item) => JSON.stringify(item) !== JSON.stringify(row))
		}
	}
</script>

<tbody>
	{#each rows as row, rowIndex (rowIndex)}
		<tr
			class="
        group
        {rowClass}
        {selectable && JSON.stringify(selectedItem) === JSON.stringify(row)
				? 'is-row-selected bg-primary-100 dark:bg-primary-900'
				: rowIndex % 2
					? 'bg-gray-50 dark:bg-gray-700'
					: 'bg-white dark:bg-gray-800'}
        {selectable && JSON.stringify(selectedItem) !== JSON.stringify(row)
				? 'dark:hover:bg-primary-800/50 hover:bg-primary-50 cursor-pointer'
				: ''}
      "
			onclick={() => handleClick(row)}
		>
			{#if multiSelect}
				<td
					class="
            group-[.is-row-selected]:border-y-primary-500
            first:group-[.is-row-selected]:border-l-primary-500 last:group-[.is-row-selected]:border-r-primary-500 border border-gray-200 border-t-transparent border-l-transparent px-4 py-2 whitespace-nowrap
            first:pl-9
            last:border-r-transparent
            last:pr-9
            dark:border-gray-500
            dark:border-t-transparent dark:border-l-transparent
        "
				>
					<div class="flex items-center">
						<Checkbox
							checked={$state
								.snapshot(selectedItems)
								.find((item) => JSON.stringify(item) === JSON.stringify(row))}
							hideLabel
							label={$_('dataGrid.selectRow')}
							small
							on:change={(event) => handleSelectChanged(event, row)}
						/>
					</div>
				</td>
			{/if}

			{#each columns as column, index (column.id)}
				{#if cell}{@render cell({ column, columns, index, row })}{:else}
					<Cell {column} {row} />
				{/if}
			{/each}
		</tr>
	{/each}
</tbody>
